import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "questionText" }
const _hoisted_2 = { class: "form-check form-check-inline" }
const _hoisted_3 = ["id", "name", "disabled"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "form-check form-check-inline" }
const _hoisted_6 = ["id", "name", "disabled"]
const _hoisted_7 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.question), 1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.yesQuestionId,
        name: _ctx.questionName,
        class: "form-check-input",
        type: "radio",
        value: "true",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAnswerChange($event))),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.yesAnswerSelected) = $event)),
        disabled: _ctx.isDisabled
      }, null, 40, _hoisted_3), [
        [_vModelRadio, _ctx.yesAnswerSelected]
      ]),
      _createElementVNode("label", {
        class: "form-check-label",
        for: _ctx.yesQuestionId
      }, " Yes ", 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.noQuestionId,
        name: _ctx.questionName,
        class: "form-check-input",
        type: "radio",
        value: "false",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAnswerChange($event))),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.noAnswerSelected) = $event)),
        disabled: _ctx.isDisabled
      }, null, 40, _hoisted_6), [
        [_vModelRadio, _ctx.noAnswerSelected]
      ]),
      _createElementVNode("label", {
        class: "form-check-label",
        for: _ctx.noQuestionId
      }, " No ", 8, _hoisted_7)
    ])
  ], 64))
}